module.exports = __webpack_public_path__ + "img/coupons_bg_en.b745eba0.png";